import Feedback from './Feedback/Feedback';

export const App = () => {
  return (
    <div>
      <Feedback />
    </div>
  );
};
